var MyDocumentsTileJS = (function() {
        var initialized = false;

        return {
            Init: function () {
                if (initialized) {
                    return;
                }

                $(window).on('resize', function() {
                    if(window.innerWidth > 1199.98) {
                        $(".faq-forms-docs-overlay").css('display', '');
                        $(".faq-forms-docs--mobile-button-container").css('display', '');
                        $("body").removeClass("faq-forms-docs-overlay-freeze");
                        $(".faq-forms-docs-mobile-search-container").css("display", "");
                        $(".faq-forms-docs-selected-filter").css("display", "")
                    } else {
                        if($('.faq-forms-docs-selected-filter-name').text()) {
                            $(".faq-forms-docs-selected-filter").css("display", "flex")
                        }
                    }
                });

                //Add space between the date and time
                $('.my-documents-document-date').each(function() {
                    const date = $(this).data('date').split(' ')[0];
                    const time = $(this).data('date').split(' ')[1];
                    const period = $(this).data('date').split(' ')[2];
                    $(this).text(date);
                    $(this).next().text(time + " " + period);
                })
                
                //Filter by Search
                $(".my-documents-search-field").keyup(function () {
                    const searchText = $(this).val() && $(this).val().toLowerCase();
                    const section = $(".my-documents-tile-section");
                    $(section).removeClass('my-document-filtered-by-text');
                    const filteredSet = new Set();

                    //Sync the 2 search fields                
                    $(".my-documents-search-field").val($(this).val());

                    $(section).each(function() {
                        let totalFilteredDocs = 0;
                        const docName = $(this).find('.my-documents-document-name');
                        $(docName).each(function() {
                            if(!!(searchText && $(this).text() && $(this).text().toLowerCase().indexOf(searchText) == -1)) {
                                getDocumentContainerElement(this).addClass('my-documents-tile-document-row-search-filtered-out');
                                totalFilteredDocs++;
                            } else {
                                getDocumentContainerElement(this).removeClass('my-documents-tile-document-row-search-filtered-out');
                            }
                        });

                        //If a sections total docs - docs filtered is less than 5, hide the "Show More/Less" button
                        if($(docName).length - totalFilteredDocs <= 5) {
                            filteredSet.add($(this));
                        }
                    });

                    //Hides the "Show More/Less" button
                    filteredSet.forEach(item => {
                        $(item).addClass('my-document-filtered-by-text');
                    })

                    updateAllAboveMaxClasses();
                });
                /*-------------------------------------*/

                //Filter by document type
                $('#my-documents-tile-select').change(function () {
                    filterByDocs($(this).val());
                });

                function filterByDocs(value) {
                    $('.my-documents-tile-document-row-year-filtered-out').removeClass('my-documents-tile-document-row-year-filtered-out');
                    const section = $(".my-documents-tile-section");

                    if(value === "View All") {
                        $(section).each(function() {
                            $(this).removeClass('d-none');
                        })
                    } else {
                        $(section).each(function() {
                            $(this).removeClass('d-none');

                            if($(this).find('.my-documents-tile-header').text() !== value){
                                $(this).addClass('d-none');
                            }
                        })
                    }

                    setFilteredName(value);
                    updateAllAboveMaxClasses();
                }

                //Resets filter
                $('.faq-forms-docs-selected-filter, .faq-forms-docs-overlay-list-item').click(function (e) {                   
                    if($(this)[0].classList.contains('faq-forms-docs-active')) {
                        //Stops the other listener from firing
                        e.stopImmediatePropagation();
                        $('.faq-forms-docs-overlay-close-button').trigger('click');
                    }
                        
                    filterByDocs("View All");
                });

                //Sets the filter chip name
                function setFilteredName(value) {
                    $('.faq-forms-docs-selected-filter-name').text(value);

                    if(value !== "View All" && window.innerWidth < 1199.98) {
                        $('.faq-forms-docs-selected-filter').css('display', 'flex');
                    } else {
                        $('.faq-forms-docs-selected-filter').css('display', '');
                    }

                    //Inverts selected overlay chip color
                    $('.faq-forms-docs-overlay-list-item').each(function() {
                        if(value !== "View All" && $(this).children().first().text() === value) {
                            $(this).addClass('faq-forms-docs-active');
                            $(this).find('i').removeClass('d-none');
                        } else {
                            $(this).removeClass('faq-forms-docs-active');
                            $(this).find('i').addClass('d-none');
                        }
                    })
                }
                
                /*-------------------------------------*/

                //Sorting
                $('.my-documents-tile-sort-button').click(function (e) {
                    const container = $(this).parent().closest('.my-documents-tile-section').find('.my-documents-tile-document-rows');
                    const elems = container.find('.my-documents-tile-document-row');
                    const sortClass = '.' + $(this).parent().data('sort-class');
                    const sortDataType = $(this).parent().data('sort-data-type');
                    const ascending = !$(this).parent().data('ascending');

                    elems.sort(function (a, b) {
                        const sortStringA = $(a).find(sortClass).text();
                        const sortStringB = $(b).find(sortClass).text();

                        if (sortDataType == 'date') {
                            return (ascending ? 1 : -1) * (new Date(sortStringA) - new Date(sortStringB));
                        } else {
                            return (ascending ? 1 : -1) * sortStringA.localeCompare(sortStringB);
                        }
                    });

                    //Rotate icons
                    const icon = $(this).find('i');
                    if(icon.hasClass('fa-arrow-up')) {
                        icon.toggleClass('fa-rotate-180');
                    }

                    if(icon.hasClass('fa-arrow-down-a-z')) {
                        icon.removeClass('fa-arrow-down-a-z');
                        icon.addClass('fa-arrow-down-z-a');
                    } else if(icon.hasClass('fa-arrow-down-z-a')) {
                        icon.removeClass('fa-arrow-down-z-a');
                        icon.addClass('fa-arrow-down-a-z');
                    }

                    container.html('');
                    container.append(elems);
                    updateAboveMaxClasses(container);

                    $(this).parent().data('ascending', ascending);
                });

                //Get the document row for an element within a document row 
                function getDocumentContainerElement(element) {
                    return $(element).closest('.my-documents-tile-document-row');
                }

                /*Changes when clicking show more*/
                $(".my-documents-show-more-show-less-container").click(function () {
                    $(this)
                        .closest('.my-documents-tile-section')
                        .toggleClass('my-documents-tile-section-show-subset');

                    $(this).find('i').toggleClass('fa-rotate-180');
                });

                function updateAllAboveMaxClasses() {
                    $('.my-documents-tile-document-rows').each(function (i, v) {
                        updateAboveMaxClasses(v);
                    });
                }

                /**
                 * Add/Remove the above-max class as necessary. This causes
                 * docs beyond the 5th to be hidden.
                 * @param {any} container The .my-documents-tile-document-rows element to have its children adjusted
                 */
                function updateAboveMaxClasses(container) {
                    $(container)
                        .find('.my-documents-tile-document-row')
                        .removeClass('my-documents-tile-document-row-above-max')
                        .filter(':not(.my-documents-tile-document-row-year-filtered-out):not(.my-documents-tile-document-row-search-filtered-out)')
                        .slice(5)
                        .addClass('my-documents-tile-document-row-above-max');
                }

                $('.faq-forms-docs-mobile-filter-button').click(function() {
                    $(".faq-forms-docs-overlay").css("display", "block");
                    $("body").addClass("faq-forms-docs-overlay-freeze");
                });
    
                $('.faq-forms-docs-overlay-close-button').click(function() {
                    $(".faq-forms-docs-overlay").css("display", "");
                    $("body").removeClass("faq-forms-docs-overlay-freeze");
                });
    
                $('.faq-forms-docs-overlay-list-item').click(function() {
                    const value = $(this).attr('value');
                    
                    filterByDocs(value);
                    //Syncs the select value
                    $('#my-documents-tile-select').val(value);

                    $('.faq-forms-docs-overlay-close-button').trigger('click');
                });
    
                $('.faq-forms-docs-mobile-search-button').click(function() {
                    $(".faq-forms-docs-mobile-button-container").css("display", "none");
                    $(".faq-forms-docs-mobile-search-container").css("display", "flex");
    
                    $(".faq-forms-docs-mobile-search-container").find('.my-documents-search-field').focus();
                });
    
                $('.faq-forms-docs-mobile-search-close').click(function() {
                    $(".faq-forms-docs-mobile-button-container").css("display", "");
                    $(".faq-forms-docs-mobile-search-container").css("display", "");
                    $(".my-documents-tile").css("margin-top", "");
                });

                initialized = true;
            }
        }
})();